module.exports = __webpack_public_path__ + "media/images/items/anim-6-030fd2c9889d0209c7042a1967b92ab6.webp";